<header class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
  <!-- Logo -->
  <div>
    <span *ngIf="showBack" class="p-0 me-2" (click)="goBack()">
      <i class="bi bi-arrow-left"></i> Back
    </span>
    <div *ngIf="!showBack" class="header-logo" routerLink="/dashboard">
      <img src="assets/images/brand-logo.png" alt="Brand Logo" style="height: 32px;" />
    </div>
  </div>

  <!-- Page title -->
  <div class="header-title text-center flex-grow-1">
    <h5 class="mb-0 fw-semibold">{{title}}</h5>
  </div>

  <!-- User profile -->
  <div class="header-profile position-relative" *ngIf="authService.user$ | async as user">
    <img *ngIf="user.profilePicture; else defaultAvatar" [src]="user?.profilePicture"
      class="rounded-circle" style="width: 36px; height: 36px;" (click)="toggleMenu()" />
    <ng-template #defaultAvatar>
      <i class="bi bi-person-circle fs-2 text-muted" (click)="toggleMenu()"></i>
    </ng-template>
    <div *ngIf="menuOpen" class="position-absolute end-0 mt-1 bg-white shadow rounded-2 p-2 border"
      style="min-width: 140px; z-index: 1050;">
      <button class="dropdown-item text-danger fw-medium" (click)="logout()">
        <i class="bi bi-box-arrow-right"></i>
        Logout
      </button>
    </div>
  </div>
</header>